import React from 'react';

export default function PublicHeader() {
	return (
		<div>
			<h3>Public header placeholder</h3>
		</div>
	);
}
